<form #form="ngForm" autocomplete="off">
    <ng-container *ngIf="review">
        <div class="app-grid">
            <ui-banner variant="info"> {{ 'performance.show.noteDialog.permissionInfo' | translate }} </ui-banner>

            <mat-form-field class="columns-12">
                <textarea
                    [placeholder]="'performance.show.noteDialog.enterNote' | translate"
                    #note="ngModel"
                    name="note"
                    [(ngModel)]="review.note"
                    rows="9"
                    [maxlength]="maxCharactersForNote"
                    matInput
                >
                </textarea>
                <mat-hint *ngIf="note.value?.length >= maxCharactersForNote">{{
                    'performance.show.noteDialog.noteHint' | translate: { x: note.value?.length }
                }}</mat-hint>
            </mat-form-field>

            <div class="columns-12 margin-bottom-1">
                <p>{{ 'performance.show.noteDialog.permissionLabel' | translate }}</p>
            </div>
            <div class="columns-12">
                <mat-checkbox
                    [(ngModel)]="review.subjectCanViewNote"
                    name="subjectCanViewNote"
                    #subjectCanViewNote="ngModel"
                >
                    {{ 'performance.show.noteDialog.revieweeSelf' | translate }}
                </mat-checkbox>
            </div>

            <div class="columns-12">
                <mat-checkbox
                    [(ngModel)]="review.participantsCanViewNote"
                    name="participantsCanViewNote"
                    #participantsCanViewNote="ngModel"
                >
                    {{ 'performance.show.noteDialog.otherReviewParticipants' | translate }}
                </mat-checkbox>
            </div>
        </div>
    </ng-container>
</form>
